export * from "./posthog-client";
export * from "./PostHogUserIdentifier";
export * from "./FeatureFlag";

import { useFeatureFlagEnabled as useFeatureFlagEnabledRaw } from "posthog-js/react";

export { PostHogProvider, usePostHog } from "posthog-js/react";

export const useFeatureFlagEnabled = (flag: string): boolean =>
  useFeatureFlagEnabledRaw(flag) ?? false;
